<template lang="html">
  <div class="inner-modal theme-color-container" ref="themeColorContainer">
		<div class="theme-color-picker-container"
				 :style="'left:' + this.colorPickerPosition.x + 'px;top:'
             + this.colorPickerPosition.y + 'px'"
				 ref="themeColorPickerContainer"
		>
			<chrome-color-picker
				v-model="colors" v-if="currentThemeColorSelected"
				v-click-outside="onClickOutside"
			/>
		</div>
		<div class="head-modal spaced-row">
			<div>
				<div class="head-modal-title">
					Ajouter/Editer un cabinet
				</div>
				<div class="head-modal-emphase">
					Modifiez les informations d’un cabinet ou ajoutez en un.
				</div>
			</div>
		<!--	<div class="row">
				<div class="head-modal-label">ACTIVATION</div>
				<toggle-input :value="cabinet.available" @change="cabinet.available = !cabinet.available" />
			</div> -->
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('cabinetId')}">
					<label for="name">Nom du cabinet</label>
					<input type="text" name="name" v-model="cabinet.name">
				</div>
				<div class="ctn-input logo-label">
					<label for="logo">Logo</label>
				</div>
				<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('cabinetId')}">
					<input type="file" name="logo" @change="getFile" accept=".png,.jpg,.jpeg,.svg">
					<img v-if="logoUrl" :src="logoUrl" height="50px">
				</div>
				<div v-if="errors.has('name')" class="error-message">{{ errors.first('name') }}</div>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('email')}">
							<label for="email">Email</label>
							<input type="text" name="email" v-model="cabinet.email">
						</div>
						<div v-if="errors.has('email')" class="error-message">{{ errors.first('email') }}</div>
					</div>
					<div class="right inner-duo">
						<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('wordpressSite')}">
							<label for="wordpressSite">Lien blog</label>
							<input  type="text" name="wordpressSite" v-model="cabinet.wordpressSite">
						</div>
						<div v-if="errors.has('wordpressSite')" class="error-message">{{ errors.first('wordpressSite') }}</div>
					</div>
				</div>
				<hr>
				<div v-if="domains.length < 4" class="add-domains" @click="addDomain">
					<div class="add-domains-items">
						<p class="add-domains-label">ajouter un domaine</p>
						<span class="icon-form-plus" />
					</div>
				</div>
				<template
					v-for="(domainInfo, index) in domains"
				>
					<domain-selector
						:domain-info="domainInfo"
						:index="index"
						:domain-types="domainTypes"
						@deleteDomain="deleteDomainAt"
						@domainUpdated="updateDomain"/>
				</template>
				<hr>
				<div class="ctn-duo-input row">
					<div class="left inner-duo">
						<div class="color-dropdown" @click="toggleColorPicker($event, 'primary')">
							<div class="color-toggle-container">
								<div class="color-toggle"
										 :style="'background-color:' + theme.colors.primary"
								></div>
								<span style="margin-left: 5px">Couleur primaire</span>
								<span class="toggle-dropdown"><i class="fas fa-angle-down"></i></span>
							</div>
						</div>
					</div>
					<div class="right inner-duo">
						<div class="color-dropdown" @click="toggleColorPicker($event, 'secondary')">
							<div class="color-toggle-container">
								<div class="color-toggle"
										 :style="'background-color:' + theme.colors.secondary"
								></div>
								<span style="margin-left: 5px">Couleur secondaire</span>
								<span class="toggle-dropdown"><i class="fas fa-angle-down"></i></span>
							</div>
						</div>
					</div>
				</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="validateBeforeSubmit">Enregistrer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>

import { Chrome } from 'vue-color';
import DomainSelector from "@/common/components/domain-selector";
const DEFAULT_CABINET = {
	name: null,
}
export default {
	name: 'AddCabinet',
	components: {DomainSelector, 'chrome-color-picker': Chrome},
	props: ['data'],
	data () {
		return {
			colorPickerPosition: { x: 0, y: 0 },
			colors: '',
			theme: {
				name: 'colors',
				colors: {
					primary: '#262a3e',
					secondary: '#b22222',
				},
			},
			logo: null,
			logoUrl: null,
			currentThemeColorSelected: null,
			adminOptions: [],
			cabinet: DEFAULT_CABINET,
			domains: [
				{
					type: null,
					domain: ''
				}
			],
			domainTypes: [
				{
					label: 'Site vitrine',
					name: 'app'
				},
				{
					label: 'Backoffice',
					name: 'admin'
				},
				{
					label: 'Cgpi',
					name: 'cgpi'
				},
				{
					label: 'Client',
					name: 'client'
				}
			]
		}
	},
	beforeMount () {
		this.$store.dispatch('getConseillers')
		.then(() => {
			this.adminOptions = this.$store.getters['conseillers']
							.filter(conseiller => conseiller.role === "Admin")
							.map(conseiller => conseiller.name)
		})
		if (this.data) {
			if (this.data.currentCabinet) {
				this.fillForm();
			} else {
				this.cabinet = {...DEFAULT_CABINET}
			}
		} else {
			this.cabinet = {...DEFAULT_CABINET}
		}
	},
	mounted () {
		if (this.data.currentCabinet == null) {
			this.cabinet = {}
		}
		console.log(this.generateThemePayload())
	},
	methods: {
		getFile (e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) {
				this.logo = null;
				this.logoUrl = null;
				return;
			}
			this.logo = files[0];
			this.readURL(files[0]);
		},
		readURL (file) {
			const reader = new FileReader();

			reader.onload = (e) => {
				this.logoUrl = e.target.result;
				console.log(this.logoUrl)
			}

			reader.readAsDataURL(file); // convert to base64 string
		},
		fillForm () {
			this.cabinet.name = this.data.currentCabinet.name;
			this.cabinet.email = this.data.currentCabinet.email;
			this.cabinet.wordpressSite = this.data.currentCabinet.wordpress_site;
			this.domains.pop();
			if (this.data.currentCabinet.client_subdomain) {
				this.domains.push(
					{
						type: { label: 'Client', name: 'client' },
						domain: this.data.currentCabinet.client_subdomain
					})
			}
			if (this.data.currentCabinet.cgpi_subdomain) {
				this.domains.push(
					{
						type: { label: 'Cgpi', name: 'cgpi' },
						domain: this.data.currentCabinet.cgpi_subdomain
					})
			}
			if (this.data.currentCabinet.admin_subdomain) {
				this.domains.push(
					{
						type: { label: 'Backoffice', name: 'admin' },
						domain: this.data.currentCabinet.admin_subdomain
					})
			}
			if (this.data.currentCabinet.app_subdomain) {
				this.domains.push(
					{
						type: { label: 'Site Vitrine', name: 'app' },
						domain: this.data.currentCabinet.app_subdomain
					})
			}
			const primary = this.data.currentCabinet.theme.params.find((param) => param.param_name === 'primary');
			const secondary = this.data.currentCabinet.theme.params.find((param) => param.param_name === 'secondary');
			this.theme.colors.primary = primary.param_value
			this.theme.colors.secondary = secondary.param_value

			if (this.data.currentCabinet.theme.logo) {
				const filename = this.data.currentCabinet.theme.logo.file;
				this.logoUrl = `${process.env.API_ROOT}api/office-asset/${filename}`
				fetch(this.logoUrl).then((response) => {
					response.blob().then((blob) => {
						this.logo = new File([blob], filename, {type: blob.type});
						this.readURL(this.logo);
					});
				});
			}
		},
		addDomain () {
			if (this.domains.length >= 4) {
				return;
			}
			this.domains.push(
				{
					name: null,
					domain: ''
				}
			)
		},
		deleteDomainAt (index) {
			this.domains.splice(index, 1);
		},
		deleteDomain () {
			this.domains.pop();
		},
		updateDomain (data) {
			this.domains[data.index] = data.domainInfo;
		},
		toggleColorPicker (event, colorType) {
			// eslint-disable-next-line max-len
			this.colorPickerPosition.x = event.pageX;
			// eslint-disable-next-line max-len
			this.colorPickerPosition.y = event.pageY;

			this.currentThemeColorSelected = colorType;

			const currentColor = this.theme.colors[colorType];

			if (currentColor) {
				this.colors = currentColor;
			}
		},
		onClickOutside (event) {
			if (!event.target.className.includes('toggle-dropdown') &&
				!event.target.className.includes('color-toggle') &&
				!event.target.className.includes('fa-angle-down')) {
				this.currentThemeColorSelected = null;
				this.colors = '';
			}
		},
		close () {
			this.cabinet = DEFAULT_CABINET
			this.$emit('close')
		},
		submit () {
			if (this.data.currentCabinet) {
				this.submitUpdate();
			} else {
				this.submitCreation();
			}
		},
		submitCreation () {
			this.$store.commit('LOADER_IN')
			this.$store.dispatch('createOffice', this.cabinet)
				.then((office) => {
					this.$store.dispatch('updateOfficeHosts', {id: office.id, payload: this.domains}).then(() => {
						this.$store.dispatch('updateOfficeTheme', {id: office.id, payload: this.generateThemePayload()}).then(() => {
							this.$store.dispatch('updateOfficeLogo', {id: office.id, logo: this.logo}).then(() => {
								this.close()
								this.cabinet = DEFAULT_CABINET
								this.$store.commit('LOADER_OUT')
							}).catch(() => this.$store.commit('LOADER_OUT'))
						}).catch(() => this.$store.commit('LOADER_OUT'))
					}).catch(() => this.$store.commit('LOADER_OUT'))
				}).catch(() => this.$store.commit('LOADER_OUT'))
		},
		submitUpdate () {
			this.$store.commit('LOADER_IN')
			this.$store.dispatch('updateOffice', { id: this.data.currentCabinet.id, payload: this.cabinet })
				.then(() => {
					this.$store.dispatch('updateOfficeHosts', {id: this.data.currentCabinet.id, payload: this.domains}).then(() => {
						this.$store.dispatch('updateOfficeTheme', {id: this.data.currentCabinet.id, payload: this.generateThemePayload()}).then(() => {
							this.$store.dispatch('updateOfficeLogo', {id: this.data.currentCabinet.id, logo: this.logo}).then(() => {
								this.close()
								this.cabinet = DEFAULT_CABINET
								this.$store.commit('LOADER_OUT')
							}).catch(() => this.$store.commit('LOADER_OUT'))
						}).catch(() => this.$store.commit('LOADER_OUT'))
					}).catch(() => this.$store.commit('LOADER_OUT'))
				}).catch(() => this.$store.commit('LOADER_OUT'))
		},
		generateThemePayload () {
			let payload = {
				name: this.theme.name
			}

			let params = []

			Object.entries(this.theme.colors).forEach((keyValue) => {
				let currentParams = {}
				currentParams.paramName = keyValue[0]
				currentParams.paramValue = keyValue[1]
				params.push(currentParams)
			})

			payload.params = params

			return payload
		},
		validateBeforeSubmit () {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.submit()
					return
				}
			});
		}
	},
	computed: {
		availableDomainTypes () {
			const usedDomanTypesName = this.domains.map((domainInfo) => domainInfo.name)

			return this.domainType.filter((domainType) => !usedDomanTypesName.includes(domainType.name))
		}
	},
	watch: {
		colors (value) {
			if (!this.currentThemeColorSelected || !value) {
				return;
			}

			const newColorValue = (typeof value.hex8 !== 'undefined') ? value.hex8 : value;

			console.log(newColorValue);

			this.theme.colors[this.currentThemeColorSelected] = newColorValue;
		},
	},
}
</script>

<style lang="css">
	.add-domains {
		display: flex;
		justify-content: flex-end;
		width: 100%;
		align-items: center;
	}

	.add-domains-items {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.add-domains-items:hover {
		color: rgb(0, 0, 50);
		cursor: pointer;
	}

	.add-domains-plus {
		cursor: pointer;
	}

	.logo-label {
		margin: 0 !important;
	}

	.add-domains-label {
		margin-right: 5px;
	}
</style>



// WEBPACK FOOTER //
// CabinetModal.vue?0ba314b6